import { ModalsSlice, UsersSlice } from '@hefe/store';
import { message, Space, Typography } from 'antd';
import { t } from '@hefe/i18n';
import React from 'react';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';

interface SendWelcomeMailFormProps {
  userIds: number[];
}

export default function SendWelcomeMailForm(props: SendWelcomeMailFormProps) {
  const dispatch = useAppDispatch();

  const submit = () => {
    const setLoading = ModalsSlice.modalsActions.setModalLoading;
    dispatch(setLoading(true));
    dispatch(UsersSlice.usersSendWelcomeMail(props.userIds))
      .unwrap()
      .then(() => {
        dispatch(ModalsSlice.modalsActions.closeModal());
        message.success(t('success.send_welcome_mail'));
      })
      .catch(() => null)
      .finally(() => dispatch(setLoading(false)));
  };

  return (
    <Space direction="vertical">
      <Typography.Paragraph>
        {t('questions.send_welcome_mail')}
      </Typography.Paragraph>
      <CustomForm
        key="send-welcome-mail"
        formId="send-welcome-mail"
        fields={[]}
        onSubmit={submit}
      />
    </Space>
  );
}
